import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase"; // ඔබේ firebase.js එකෙන් db එක import කරගන්න
import "./AlbumView.css";

const AlbumView = () => {
  const { albumName } = useParams();
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentAlbumName, setCurrentAlbumName] = useState("");

  // 🔥 Lightbox
  const [currentIndex, setCurrentIndex] = useState(null);

  const formatTitle = (name) =>
    name ? name.replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";

  // Firestore එකෙන් collection_albums collection එක හරහා images fetch කරගැනීම
  useEffect(() => {
    const loadImagesFromFirestore = async () => {
      setLoading(true);
      try {
        const decodedAlbumName = decodeURIComponent(albumName);

        // collection_albums collection එකෙන් ඩේටා ලබා ගැනීම
        const querySnapshot = await getDocs(collection(db, "collection_albums"));
        
        let foundImages = [];
        let realName = decodedAlbumName;

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // document ID එක හෝ albumName එක match වෙනවද බැලීම
          if (doc.id === decodedAlbumName || data.albumName === decodedAlbumName) {
            foundImages = data.images || [];
            realName = data.albumName || decodedAlbumName;
          }
        });

        setImages(foundImages);
        setCurrentAlbumName(realName);
      } catch (err) {
        console.error("Error loading collection album: ", err);
        setImages([]);
      } finally {
        setLoading(false);
      }
    };

    loadImagesFromFirestore();
  }, [albumName]);

  /* -------- Lightbox controls -------- */
  const closeLightbox = () => setCurrentIndex(null);

  const nextImage = () =>
    setCurrentIndex((prev) => (prev + 1) % images.length);

  const prevImage = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  // ⌨ keyboard
  useEffect(() => {
    const handleKey = (e) => {
      if (currentIndex === null) return;

      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [currentIndex, images.length]);

  return (
    <div className="album-page">
      {/* Header */}
      <div className="album-header">
        <button className="album-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1 className="album-title">{formatTitle(currentAlbumName)}</h1>
        <p className="album-count">{images.length} photographs</p>
      </div>

      {/* Gallery / Loading */}
      {loading ? (
        <div className="album-loading">
          <div className="skeleton-grid">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton-box"></div>
            ))}
          </div>
        </div>
      ) : images.length === 0 ? (
        <p style={{ textAlign: "center", padding: "50px 0" }}>No photographs found</p>
      ) : (
        <div className="album-gallery">
          {images.map((url, i) => (
            <div
              key={i}
              className="album-image-wrapper"
              onClick={() => setCurrentIndex(i)}
            >
              <img src={url} alt={`img-${i}`} loading="lazy" />
            </div>
          ))}
        </div>
      )}

      {/* -------- FULLSCREEN LIGHTBOX -------- */}
      {currentIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            ✕
          </button>

          <button
            className="lightbox-nav prev"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            ‹
          </button>

          <img
            src={images[currentIndex]}
            alt="fullscreen"
            className="lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="lightbox-nav next"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default AlbumView;